import { normalize, schema } from 'normalizr';

import { createRetailTransformers } from 'pages/store/transformers/retail';

export const entity = 'preAuthorizationEmail';
export const entitySchema = new schema.Entity(
  entity,
  {},
  {
    idAttribute: 'id',
  }
);
export const normalizer = (result) => normalize(result, entitySchema);
export const listNormalizer = (result) => normalize(result, [entitySchema]);

// PreAuthorizationEmail Transformers
export const { transformer, listTransformer } = createRetailTransformers('PreAuthorizationEmail');
